export enum CplRoles {
    Paraeducator = 'Paraeducator',
    Emergency_Cert = 'Emergency_Cert',
    Volunteer = 'Volunteer'
}